import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Paper,
  Typography,
  Button,
  Grid,
  AppBar,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Alert,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Divider,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  InputAdornment,
  Tooltip,
  FormHelperText,
  Snackbar
} from '@mui/material';
import {
  Add as AddIcon,
  Remove as RemoveIcon,
  Logout as LogoutIcon,
  Business as BusinessIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Save as SaveIcon,
  Restore as RestoreIcon,
  Lock as LockIcon,
  Visibility as VisibilityIcon
} from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';
import { useResponsive } from '../hooks/useResponsive';
import axios from 'axios';
import DetailView from './DetailView';
import { BACKEND_BASE_URL } from '../config';

// Manually paste the country code JSON data here after fetching it from the web search result.
const countryData = [
  {
    "name": "Afghanistan",
    "dial_code": "+93",
    "code": "AF"
  },
  {
    "name": "Aland Islands",
    "dial_code": "+358",
    "code": "AX"
  },
  {
    "name": "Albania",
    "dial_code": "+355",
    "code": "AL"
  },
  {
    "name": "Algeria",
    "dial_code": "+213",
    "code": "DZ"
  },
  {
    "name": "AmericanSamoa",
    "dial_code": "+1684",
    "code": "AS"
  },
  {
    "name": "Andorra",
    "dial_code": "+376",
    "code": "AD"
  },
  {
    "name": "Angola",
    "dial_code": "+244",
    "code": "AO"
  },
  {
    "name": "Anguilla",
    "dial_code": "+1264",
    "code": "AI"
  },
  {
    "name": "Antarctica",
    "dial_code": "+672",
    "code": "AQ"
  },
  {
    "name": "Antigua and Barbuda",
    "dial_code": "+1268",
    "code": "AG"
  },
  {
    "name": "Argentina",
    "dial_code": "+54",
    "code": "AR"
  },
  {
    "name": "Armenia",
    "dial_code": "+374",
    "code": "AM"
  },
  {
    "name": "Aruba",
    "dial_code": "+297",
    "code": "AW"
  },
  {
    "name": "Australia",
    "dial_code": "+61",
    "code": "AU"
  },
  {
    "name": "Austria",
    "dial_code": "+43",
    "code": "AT"
  },
  {
    "name": "Azerbaijan",
    "dial_code": "+994",
    "code": "AZ"
  },
  {
    "name": "Bahamas",
    "dial_code": "+1242",
    "code": "BS"
  },
  {
    "name": "Bahrain",
    "dial_code": "+973",
    "code": "BH"
  },
  {
    "name": "Bangladesh",
    "dial_code": "+880",
    "code": "BD"
  },
  {
    "name": "Barbados",
    "dial_code": "+1246",
    "code": "BB"
  },
  {
    "name": "Belarus",
    "dial_code": "+375",
    "code": "BY"
  },
  {
    "name": "Belgium",
    "dial_code": "+32",
    "code": "BE"
  },
  {
    "name": "Belize",
    "dial_code": "+501",
    "code": "BZ"
  },
  {
    "name": "Benin",
    "dial_code": "+229",
    "code": "BJ"
  },
  {
    "name": "Bermuda",
    "dial_code": "+1441",
    "code": "BM"
  },
  {
    "name": "Bhutan",
    "dial_code": "+975",
    "code": "BT"
  },
  {
    "name": "Bolivia, Plurinational State of",
    "dial_code": "+591",
    "code": "BO"
  },
  {
    "name": "Bosnia and Herzegovina",
    "dial_code": "+387",
    "code": "BA"
  },
  {
    "name": "Botswana",
    "dial_code": "+267",
    "code": "BW"
  },
  {
    "name": "Brazil",
    "dial_code": "+55",
    "code": "BR"
  },
  {
    "name": "British Indian Ocean Territory",
    "dial_code": "+246",
    "code": "IO"
  },
  {
    "name": "Brunei Darussalam",
    "dial_code": "+673",
    "code": "BN"
  },
  {
    "name": "Bulgaria",
    "dial_code": "+359",
    "code": "BG"
  },
  {
    "name": "Burkina Faso",
    "dial_code": "+226",
    "code": "BF"
  },
  {
    "name": "Burundi",
    "dial_code": "+257",
    "code": "BI"
  },
  {
    "name": "Cambodia",
    "dial_code": "+855",
    "code": "KH"
  },
  {
    "name": "Cameroon",
    "dial_code": "+237",
    "code": "CM"
  },
  {
    "name": "Canada",
    "dial_code": "+1",
    "code": "CA"
  },
  {
    "name": "Cape Verde",
    "dial_code": "+238",
    "code": "CV"
  },
  {
    "name": "Cayman Islands",
    "dial_code": "+ 345",
    "code": "KY"
  },
  {
    "name": "Central African Republic",
    "dial_code": "+236",
    "code": "CF"
  },
  {
    "name": "Chad",
    "dial_code": "+235",
    "code": "TD"
  },
  {
    "name": "Chile",
    "dial_code": "+56",
    "code": "CL"
  },
  {
    "name": "China",
    "dial_code": "+86",
    "code": "CN"
  },
  {
    "name": "Christmas Island",
    "dial_code": "+61",
    "code": "CX"
  },
  {
    "name": "Cocos (Keeling) Islands",
    "dial_code": "+61",
    "code": "CC"
  },
  {
    "name": "Colombia",
    "dial_code": "+57",
    "code": "CO"
  },
  {
    "name": "Comoros",
    "dial_code": "+269",
    "code": "KM"
  },
  {
    "name": "Congo",
    "dial_code": "+242",
    "code": "CG"
  },
  {
    "name": "Congo, The Democratic Republic of the Congo",
    "dial_code": "+243",
    "code": "CD"
  },
  {
    "name": "Cook Islands",
    "dial_code": "+682",
    "code": "CK"
  },
  {
    "name": "Costa Rica",
    "dial_code": "+506",
    "code": "CR"
  },
  {
    "name": "Cote d'Ivoire",
    "dial_code": "+225",
    "code": "CI"
  },
  {
    "name": "Croatia",
    "dial_code": "+385",
    "code": "HR"
  },
  {
    "name": "Cuba",
    "dial_code": "+53",
    "code": "CU"
  },
  {
    "name": "Cyprus",
    "dial_code": "+357",
    "code": "CY"
  },
  {
    "name": "Czech Republic",
    "dial_code": "+420",
    "code": "CZ"
  },
  {
    "name": "Denmark",
    "dial_code": "+45",
    "code": "DK"
  },
  {
    "name": "Djibouti",
    "dial_code": "+253",
    "code": "DJ"
  },
  {
    "name": "Dominica",
    "dial_code": "+1767",
    "code": "DM"
  },
  {
    "name": "Dominican Republic",
    "dial_code": "+1849",
    "code": "DO"
  },
  {
    "name": "Ecuador",
    "dial_code": "+593",
    "code": "EC"
  },
  {
    "name": "Egypt",
    "dial_code": "+20",
    "code": "EG"
  },
  {
    "name": "El Salvador",
    "dial_code": "+503",
    "code": "SV"
  },
  {
    "name": "Equatorial Guinea",
    "dial_code": "+240",
    "code": "GQ"
  },
  {
    "name": "Eritrea",
    "dial_code": "+291",
    "code": "ER"
  },
  {
    "name": "Estonia",
    "dial_code": "+372",
    "code": "EE"
  },
  {
    "name": "Ethiopia",
    "dial_code": "+251",
    "code": "ET"
  },
  {
    "name": "Falkland Islands (Malvinas)",
    "dial_code": "+500",
    "code": "FK"
  },
  {
    "name": "Faroe Islands",
    "dial_code": "+298",
    "code": "FO"
  },
  {
    "name": "Fiji",
    "dial_code": "+679",
    "code": "FJ"
  },
  {
    "name": "Finland",
    "dial_code": "+358",
    "code": "FI"
  },
  {
    "name": "France",
    "dial_code": "+33",
    "code": "FR"
  },
  {
    "name": "French Guiana",
    "dial_code": "+594",
    "code": "GF"
  },
  {
    "name": "French Polynesia",
    "dial_code": "+689",
    "code": "PF"
  },
  {
    "name": "Gabon",
    "dial_code": "+241",
    "code": "GA"
  },
  {
    "name": "Gambia",
    "dial_code": "+220",
    "code": "GM"
  },
  {
    "name": "Georgia",
    "dial_code": "+995",
    "code": "GE"
  },
  {
    "name": "Germany",
    "dial_code": "+49",
    "code": "DE"
  },
  {
    "name": "Ghana",
    "dial_code": "+233",
    "code": "GH"
  },
  {
    "name": "Gibraltar",
    "dial_code": "+350",
    "code": "GI"
  },
  {
    "name": "Greece",
    "dial_code": "+30",
    "code": "GR"
  },
  {
    "name": "Greenland",
    "dial_code": "+299",
    "code": "GL"
  },
  {
    "name": "Grenada",
    "dial_code": "+1473",
    "code": "GD"
  },
  {
    "name": "Guadeloupe",
    "dial_code": "+590",
    "code": "GP"
  },
  {
    "name": "Guam",
    "dial_code": "+1671",
    "code": "GU"
  },
  {
    "name": "Guatemala",
    "dial_code": "+502",
    "code": "GT"
  },
  {
    "name": "Guernsey",
    "dial_code": "+44",
    "code": "GG"
  },
  {
    "name": "Guinea",
    "dial_code": "+224",
    "code": "GN"
  },
  {
    "name": "Guinea-Bissau",
    "dial_code": "+245",
    "code": "GW"
  },
  {
    "name": "Guyana",
    "dial_code": "+595",
    "code": "GY"
  },
  {
    "name": "Haiti",
    "dial_code": "+509",
    "code": "HT"
  },
  {
    "name": "Holy See (Vatican City State)",
    "dial_code": "+379",
    "code": "VA"
  },
  {
    "name": "Honduras",
    "dial_code": "+504",
    "code": "HN"
  },
  {
    "name": "Hong Kong",
    "dial_code": "+852",
    "code": "HK"
  },
  {
    "name": "Hungary",
    "dial_code": "+36",
    "code": "HU"
  },
  {
    "name": "Iceland",
    "dial_code": "+354",
    "code": "IS"
  },
  {
    "name": "India",
    "dial_code": "+91",
    "code": "IN"
  },
  {
    "name": "Indonesia",
    "dial_code": "+62",
    "code": "ID"
  },
  {
    "name": "Iran, Islamic Republic of Persian Gulf",
    "dial_code": "+98",
    "code": "IR"
  },
  {
    "name": "Iraq",
    "dial_code": "+964",
    "code": "IQ"
  },
  {
    "name": "Ireland",
    "dial_code": "+353",
    "code": "IE"
  },
  {
    "name": "Isle of Man",
    "dial_code": "+44",
    "code": "IM"
  },
  {
    "name": "Israel",
    "dial_code": "+972",
    "code": "IL"
  },
  {
    "name": "Italy",
    "dial_code": "+39",
    "code": "IT"
  },
  {
    "name": "Jamaica",
    "dial_code": "+1876",
    "code": "JM"
  },
  {
    "name": "Japan",
    "dial_code": "+81",
    "code": "JP"
  },
  {
    "name": "Jersey",
    "dial_code": "+44",
    "code": "JE"
  },
  {
    "name": "Jordan",
    "dial_code": "+962",
    "code": "JO"
  },
  {
    "name": "Kazakhstan",
    "dial_code": "+77",
    "code": "KZ"
  },
  {
    "name": "Kenya",
    "dial_code": "+254",
    "code": "KE"
  },
  {
    "name": "Kiribati",
    "dial_code": "+686",
    "code": "KI"
  },
  {
    "name": "Korea, Democratic People's Republic of Korea",
    "dial_code": "+850",
    "code": "KP"
  },
  {
    "name": "Korea, Republic of South Korea",
    "dial_code": "+82",
    "code": "KR"
  },
  {
    "name": "Kuwait",
    "dial_code": "+965",
    "code": "KW"
  },
  {
    "name": "Kyrgyzstan",
    "dial_code": "+996",
    "code": "KG"
  },
  {
    "name": "Laos",
    "dial_code": "+856",
    "code": "LA"
  },
  {
    "name": "Latvia",
    "dial_code": "+371",
    "code": "LV"
  },
  {
    "name": "Lebanon",
    "dial_code": "+961",
    "code": "LB"
  },
  {
    "name": "Lesotho",
    "dial_code": "+266",
    "code": "LS"
  },
  {
    "name": "Liberia",
    "dial_code": "+231",
    "code": "LR"
  },
  {
    "name": "Libyan Arab Jamahiriya",
    "dial_code": "+218",
    "code": "LY"
  },
  {
    "name": "Liechtenstein",
    "dial_code": "+423",
    "code": "LI"
  },
  {
    "name": "Lithuania",
    "dial_code": "+370",
    "code": "LT"
  },
  {
    "name": "Luxembourg",
    "dial_code": "+352",
    "code": "LU"
  },
  {
    "name": "Macao",
    "dial_code": "+853",
    "code": "MO"
  },
  {
    "name": "Macedonia",
    "dial_code": "+389",
    "code": "MK"
  },
  {
    "name": "Madagascar",
    "dial_code": "+261",
    "code": "MG"
  },
  {
    "name": "Malawi",
    "dial_code": "+265",
    "code": "MW"
  },
  {
    "name": "Malaysia",
    "dial_code": "+60",
    "code": "MY"
  },
  {
    "name": "Maldives",
    "dial_code": "+960",
    "code": "MV"
  },
  {
    "name": "Mali",
    "dial_code": "+223",
    "code": "ML"
  },
  {
    "name": "Malta",
    "dial_code": "+356",
    "code": "MT"
  },
  {
    "name": "Marshall Islands",
    "dial_code": "+692",
    "code": "MH"
  },
  {
    "name": "Martinique",
    "dial_code": "+596",
    "code": "MQ"
  },
  {
    "name": "Mauritania",
    "dial_code": "+222",
    "code": "MR"
  },
  {
    "name": "Mauritius",
    "dial_code": "+230",
    "code": "MU"
  },
  {
    "name": "Mayotte",
    "dial_code": "+262",
    "code": "YT"
  },
  {
    "name": "Mexico",
    "dial_code": "+52",
    "code": "MX"
  },
  {
    "name": "Micronesia, Federated States of Micronesia",
    "dial_code": "+691",
    "code": "FM"
  },
  {
    "name": "Moldova",
    "dial_code": "+373",
    "code": "MD"
  },
  {
    "name": "Monaco",
    "dial_code": "+377",
    "code": "MC"
  },
  {
    "name": "Mongolia",
    "dial_code": "+976",
    "code": "MN"
  },
  {
    "name": "Montenegro",
    "dial_code": "+382",
    "code": "ME"
  },
  {
    "name": "Montserrat",
    "dial_code": "+1664",
    "code": "MS"
  },
  {
    "name": "Morocco",
    "dial_code": "+212",
    "code": "MA"
  },
  {
    "name": "Mozambique",
    "dial_code": "+258",
    "code": "MZ"
  },
  {
    "name": "Myanmar",
    "dial_code": "+95",
    "code": "MM"
  },
  {
    "name": "Namibia",
    "dial_code": "+264",
    "code": "NA"
  },
  {
    "name": "Nauru",
    "dial_code": "+674",
    "code": "NR"
  },
  {
    "name": "Nepal",
    "dial_code": "+977",
    "code": "NP"
  },
  {
    "name": "Netherlands",
    "dial_code": "+31",
    "code": "NL"
  },
  {
    "name": "Netherlands Antilles",
    "dial_code": "+599",
    "code": "AN"
  },
  {
    "name": "New Caledonia",
    "dial_code": "+687",
    "code": "NC"
  },
  {
    "name": "New Zealand",
    "dial_code": "+64",
    "code": "NZ"
  },
  {
    "name": "Nicaragua",
    "dial_code": "+505",
    "code": "NI"
  },
  {
    "name": "Niger",
    "dial_code": "+227",
    "code": "NE"
  },
  {
    "name": "Nigeria",
    "dial_code": "+234",
    "code": "NG"
  },
  {
    "name": "Niue",
    "dial_code": "+683",
    "code": "NU"
  },
  {
    "name": "Norfolk Island",
    "dial_code": "+672",
    "code": "NF"
  },
  {
    "name": "Northern Mariana Islands",
    "dial_code": "+1670",
    "code": "MP"
  },
  {
    "name": "Norway",
    "dial_code": "+47",
    "code": "NO"
  },
  {
    "name": "Oman",
    "dial_code": "+968",
    "code": "OM"
  },
  {
    "name": "Pakistan",
    "dial_code": "+92",
    "code": "PK"
  },
  {
    "name": "Palau",
    "dial_code": "+680",
    "code": "PW"
  },
  {
    "name": "Palestinian Territory, Occupied",
    "dial_code": "+970",
    "code": "PS"
  },
  {
    "name": "Panama",
    "dial_code": "+507",
    "code": "PA"
  },
  {
    "name": "Papua New Guinea",
    "dial_code": "+675",
    "code": "PG"
  },
  {
    "name": "Paraguay",
    "dial_code": "+595",
    "code": "PY"
  },
  {
    "name": "Peru",
    "dial_code": "+51",
    "code": "PE"
  },
  {
    "name": "Philippines",
    "dial_code": "+63",
    "code": "PH"
  },
  {
    "name": "Pitcairn",
    "dial_code": "+872",
    "code": "PN"
  },
  {
    "name": "Poland",
    "dial_code": "+48",
    "code": "PL"
  },
  {
    "name": "Portugal",
    "dial_code": "+351",
    "code": "PT"
  },
  {
    "name": "Puerto Rico",
    "dial_code": "+1939",
    "code": "PR"
  },
  {
    "name": "Qatar",
    "dial_code": "+974",
    "code": "QA"
  },
  {
    "name": "Romania",
    "dial_code": "+40",
    "code": "RO"
  },
  {
    "name": "Russia",
    "dial_code": "+7",
    "code": "RU"
  },
  {
    "name": "Rwanda",
    "dial_code": "+250",
    "code": "RW"
  },
  {
    "name": "Reunion",
    "dial_code": "+262",
    "code": "RE"
  },
  {
    "name": "Saint Barthelemy",
    "dial_code": "+590",
    "code": "BL"
  },
  {
    "name": "Saint Helena, Ascension and Tristan Da Cunha",
    "dial_code": "+290",
    "code": "SH"
  },
  {
    "name": "Saint Kitts and Nevis",
    "dial_code": "+1869",
    "code": "KN"
  },
  {
    "name": "Saint Lucia",
    "dial_code": "+1758",
    "code": "LC"
  },
  {
    "name": "Saint Martin",
    "dial_code": "+590",
    "code": "MF"
  },
  {
    "name": "Saint Pierre and Miquelon",
    "dial_code": "+508",
    "code": "PM"
  },
  {
    "name": "Saint Vincent and the Grenadines",
    "dial_code": "+1784",
    "code": "VC"
  },
  {
    "name": "Samoa",
    "dial_code": "+685",
    "code": "WS"
  },
  {
    "name": "San Marino",
    "dial_code": "+378",
    "code": "SM"
  },
  {
    "name": "Sao Tome and Principe",
    "dial_code": "+239",
    "code": "ST"
  },
  {
    "name": "Saudi Arabia",
    "dial_code": "+966",
    "code": "SA"
  },
  {
    "name": "Senegal",
    "dial_code": "+221",
    "code": "SN"
  },
  {
    "name": "Serbia",
    "dial_code": "+381",
    "code": "RS"
  },
  {
    "name": "Seychelles",
    "dial_code": "+248",
    "code": "SC"
  },
  {
    "name": "Sierra Leone",
    "dial_code": "+232",
    "code": "SL"
  },
  {
    "name": "Singapore",
    "dial_code": "+65",
    "code": "SG"
  },
  {
    "name": "Slovakia",
    "dial_code": "+421",
    "code": "SK"
  },
  {
    "name": "Slovenia",
    "dial_code": "+386",
    "code": "SI"
  },
  {
    "name": "Solomon Islands",
    "dial_code": "+677",
    "code": "SB"
  },
  {
    "name": "Somalia",
    "dial_code": "+252",
    "code": "SO"
  },
  {
    "name": "South Africa",
    "dial_code": "+27",
    "code": "ZA"
  },
  {
    "name": "South Sudan",
    "dial_code": "+211",
    "code": "SS"
  },
  {
    "name": "South Georgia and the South Sandwich Islands",
    "dial_code": "+500",
    "code": "GS"
  },
  {
    "name": "Spain",
    "dial_code": "+34",
    "code": "ES"
  },
  {
    "name": "Sri Lanka",
    "dial_code": "+94",
    "code": "LK"
  },
  {
    "name": "Sudan",
    "dial_code": "+249",
    "code": "SD"
  },
  {
    "name": "Suriname",
    "dial_code": "+597",
    "code": "SR"
  },
  {
    "name": "Svalbard and Jan Mayen",
    "dial_code": "+47",
    "code": "SJ"
  },
  {
    "name": "Swaziland",
    "dial_code": "+268",
    "code": "SZ"
  },
  {
    "name": "Sweden",
    "dial_code": "+46",
    "code": "SE"
  },
  {
    "name": "Switzerland",
    "dial_code": "+41",
    "code": "CH"
  },
  {
    "name": "Syrian Arab Republic",
    "dial_code": "+963",
    "code": "SY"
  },
  {
    "name": "Taiwan",
    "dial_code": "+886",
    "code": "TW"
  },
  {
    "name": "Tajikistan",
    "dial_code": "+992",
    "code": "TJ"
  },
  {
    "name": "Tanzania, United Republic of Tanzania",
    "dial_code": "+255",
    "code": "TZ"
  },
  {
    "name": "Thailand",
    "dial_code": "+66",
    "code": "TH"
  },
  {
    "name": "Timor-Leste",
    "dial_code": "+670",
    "code": "TL"
  },
  {
    "name": "Togo",
    "dial_code": "+228",
    "code": "TG"
  },
  {
    "name": "Tokelau",
    "dial_code": "+690",
    "code": "TK"
  },
  {
    "name": "Tonga",
    "dial_code": "+676",
    "code": "TO"
  },
  {
    "name": "Trinidad and Tobago",
    "dial_code": "+1868",
    "code": "TT"
  },
  {
    "name": "Tunisia",
    "dial_code": "+216",
    "code": "TN"
  },
  {
    "name": "Turkey",
    "dial_code": "+90",
    "code": "TR"
  },
  {
    "name": "Turkmenistan",
    "dial_code": "+993",
    "code": "TM"
  },
  {
    "name": "Turks and Caicos Islands",
    "dial_code": "+1649",
    "code": "TC"
  },
  {
    "name": "Tuvalu",
    "dial_code": "+688",
    "code": "TV"
  },
  {
    "name": "Uganda",
    "dial_code": "+256",
    "code": "UG"
  },
  {
    "name": "Ukraine",
    "dial_code": "+380",
    "code": "UA"
  },
  {
    "name": "United Arab Emirates",
    "dial_code": "+971",
    "code": "AE"
  },
  {
    "name": "United Kingdom",
    "dial_code": "+44",
    "code": "GB"
  },
  {
    "name": "United States",
    "dial_code": "+1",
    "code": "US"
  },
  {
    "name": "Uruguay",
    "dial_code": "+598",
    "code": "UY"
  },
  {
    "name": "Uzbekistan",
    "dial_code": "+998",
    "code": "UZ"
  },
  {
    "name": "Vanuatu",
    "dial_code": "+678",
    "code": "VU"
  },
  {
    "name": "Venezuela, Bolivarian Republic of Venezuela",
    "dial_code": "+58",
    "code": "VE"
  },
  {
    "name": "Vietnam",
    "dial_code": "+84",
    "code": "VN"
  },
  {
    "name": "Virgin Islands, British",
    "dial_code": "+1284",
    "code": "VG"
  },
  {
    "name": "Virgin Islands, U.S."
  },
  {
    "name": "Wallis and Futuna",
    "dial_code": "+681",
    "code": "WF"
  },
  {
    "name": "Yemen",
    "dial_code": "+967",
    "code": "YE"
  },
  {
    "name": "Zambia",
    "dial_code": "+260",
    "code": "ZM"
  },
  {
    "name": "Zimbabwe",
    "dial_code": "+263",
    "code": "ZW"
  }
];

const fadeInOut = {
  '@keyframes fadeInOut': {
    '0%': {
      opacity: 0,
      transform: 'translateY(-20px)'
    },
    '10%': {
      opacity: 1,
      transform: 'translateY(0)'
    },
    '90%': {
      opacity: 1,
      transform: 'translateY(0)'
    },
    '100%': {
      opacity: 0,
      transform: 'translateY(-20px)'
    }
  }
};

function AdminDashboard() {
  const [clients, setClients] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [error, setError] = useState('');
  const [selectedItem, setSelectedItem] = useState(null);
  const [detailViewType, setDetailViewType] = useState(null);
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { isSmallMobile, isMobile } = useResponsive();

  const [clientForm, setClientForm] = useState({
    open: false,
    mode: 'add', // 'add' or 'edit'
    data: {
      organization_name: '',
      spoc_name: '',
      address: '',
      phone: '',
      email: '',
      mobile_number: '',
      country_code: '+91',
      country: 'India',
      password: '',
      confirmPassword: '',
      type: '',
      registration_number: '',
      gst_number: ''
    },
    errors: {}
  });

  const [formErrors, setFormErrors] = useState({});
  const [countryCodeSearch, setCountryCodeSearch] = useState('');
  const [filteredCountryCodes, setFilteredCountryCodes] = useState(countryData);

  const organizationTypes = [
    'Concessionaire',
    '⁠Service Provider',
    '⁠NGO',
    '⁠Government',
    '⁠InvIT',
    'SPV',
  ];

  const [draft, setDraft] = useState(null);
  const [tempError, setTempError] = useState('');

  // Add new state for password
  const [passwordDialog, setPasswordDialog] = useState({
    open: false,
    clientId: null,
    newPassword: '',
    confirmPassword: '',
    errors: {}
  });

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  useEffect(() => {
    if (!user) {
      navigate('/admin/login');
      return;
    }
    fetchClients();
  }, [user, navigate]);

  // Add useEffect to filter country codes based on search input
  useEffect(() => {
    setFilteredCountryCodes(
      countryData.filter(
        (country) =>
          country.name.toLowerCase().includes(countryCodeSearch.toLowerCase()) ||
          country.dial_code.includes(countryCodeSearch)
      )
    );
  }, [countryCodeSearch]);

  const fetchClients = async () => {
    try {
      const response = await axios.get(`${BACKEND_BASE_URL}/api/admin/clients`);
      setClients(response.data);
    } catch (error) {
      setError('Failed to fetch clients');
    }
  };

  const handleAddClient = () => {
    setClientForm({
      open: true,
      mode: 'add',
      data: {
        organization_name: '',
        spoc_name: '',
        address: '',
        phone: '',
        email: '',
        mobile_number: '',
        country_code: '+91',
        country: 'India',
        password: '',
        confirmPassword: '',
        type: '',
        registration_number: '',
        gst_number: ''
      },
      errors: {}
    });
    // Load draft if exists
    const savedDraft = localStorage.getItem('clientDraft');
    if (savedDraft) {
      setDraft(JSON.parse(savedDraft));
      setClientForm(prev => ({ ...prev, data: JSON.parse(savedDraft) }));
    }
  };

  const handleEditClient = (client) => {
    // Split mobile number to get country code and number
    const mobileParts = client.mobile_number.split(' ');
    const countryCode = mobileParts[0] || '+91';
    const mobileNumber = mobileParts[1] || '';

    setClientForm({
      open: true,
      mode: 'edit',
      data: {
        _id: client._id,
        organization_name: client.organization_name,
        spoc_name: client.spoc_name || '',
        address: client.address || '',
        phone: client.phone || '',
        email: client.email,
        mobile_number: mobileNumber,
        country_code: countryCode,
        country: client.country || 'India',
        type: client.type,
        registration_number: client.registration_number,
        gst_number: client.gst_number,
        password: '',
        confirmPassword: ''
      },
      errors: {}
    });
  };

  const validateClientForm = () => {
    const errors = {};
    if (!clientForm.data.organization_name) errors.organization_name = 'Organization Name is required';
    if (!clientForm.data.email) errors.email = 'Email is required';
    if (!clientForm.data.mobile_number) errors.mobile_number = 'Mobile number is required';
    if (!clientForm.data.type) errors.type = 'Organization Type is required';
    if (!clientForm.data.address) errors.address = 'Address is required';
    if (!clientForm.data.registration_number) errors.registration_number = 'Registration Number is required';
    if (!clientForm.data.gst_number) errors.gst_number = 'GST Number is required';
    
    // Password validation only for new clients
    if (clientForm.mode === 'add') {
      if (!clientForm.data.password) errors.password = 'Password is required';
      if (!clientForm.data.confirmPassword) errors.confirmPassword = 'Please confirm your password';
      if (clientForm.data.password !== clientForm.data.confirmPassword) {
        errors.confirmPassword = 'Passwords do not match';
      }
    }

    return errors;
  };

  const handleCloseSnackbar = () => {
    setSnackbar(prev => ({ ...prev, open: false }));
  };

  const handleClientSubmit = async (e) => {
    e.preventDefault();
    const errors = validateClientForm();
    if (Object.keys(errors).length > 0) {
      setClientForm(prev => ({ ...prev, errors }));
      return;
    }

    try {
      const { confirmPassword, ...dataToSend } = clientForm.data;
      // Format mobile number with country code
      dataToSend.mobile_number = `${dataToSend.country_code} ${dataToSend.mobile_number}`;

      if (clientForm.mode === 'add') {
        await axios.post(`${BACKEND_BASE_URL}/api/admin/clients`, dataToSend);
        setSnackbar({
          open: true,
          message: 'Client added successfully',
          severity: 'success'
        });
        setTimeout(handleCloseSnackbar, 3000);
      } else {
        await axios.put(`${BACKEND_BASE_URL}/api/admin/clients/${clientForm.data._id}`, dataToSend);
        setSnackbar({
          open: true,
          message: 'Client updated successfully',
          severity: 'success'
        });
        setTimeout(handleCloseSnackbar, 3000);
      }
      fetchClients();
      setClientForm(prev => ({ ...prev, open: false }));
    } catch (error) {
      if (error.response?.data?.error) {
        setClientForm(prev => ({
          ...prev,
          errors: { [error.response.data.field]: error.response.data.error }
        }));
      }
    }
  };

  const handleDeleteClient = async (clientId) => {
    if (window.confirm('Are you sure you want to delete this client? This will also delete all associated vendors, projects, routes, and progress data.')) {
      try {
        await axios.delete(`${BACKEND_BASE_URL}/api/admin/clients/${clientId}`);
        fetchClients();
      } catch (error) {
        setError('Failed to delete client');
      }
    }
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleShowDetails = (client, type) => {
    setSelectedItem(client);
    setDetailViewType(type);
  };

  const handleSaveDraft = () => {
    const draftData = { ...clientForm.data };
    localStorage.setItem('clientDraft', JSON.stringify(draftData));
    setDraft(draftData);
  };

  const handleLoadDraft = () => {
    if (draft) {
      setClientForm(prev => ({ ...prev, data: draft }));
    }
  };

  const handleClearForm = () => {
    setClientForm({
      open: false,
      mode: 'add',
      data: {
        organization_name: '',
        spoc_name: '',
        address: '',
        phone: '',
        email: '',
        mobile_number: '',
        country_code: '+91',
        country: 'India',
        password: '',
        confirmPassword: '',
        type: '',
        registration_number: '',
        gst_number: ''
      },
      errors: {}
    });
    localStorage.removeItem('clientDraft');
    setDraft(null);
  };

  const handlePasswordUpdate = async () => {
    // Validate passwords
    const errors = {};
    if (!passwordDialog.newPassword) {
      errors.newPassword = 'Password is required';
    }
    if (!passwordDialog.confirmPassword) {
      errors.confirmPassword = 'Please confirm your password';
    }
    if (passwordDialog.newPassword !== passwordDialog.confirmPassword) {
      errors.confirmPassword = 'Passwords do not match';
    }

    if (Object.keys(errors).length > 0) {
      setPasswordDialog(prev => ({ ...prev, errors }));
      return;
    }

    try {
      await axios.put(`${BACKEND_BASE_URL}/api/admin/clients/${passwordDialog.clientId}/password`, {
        password: passwordDialog.newPassword
      });
      setPasswordDialog({
        open: false,
        clientId: null,
        newPassword: '',
        confirmPassword: '',
        errors: {}
      });
      setTempError('Password updated successfully');
    } catch (error) {
      setTempError('Failed to update password');
    }
  };

  return (
    <Box sx={{ flexGrow: 1, height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <AppBar position="static" sx={{ backgroundColor: '#F79233' }}>
        <Box sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          px: isSmallMobile ? 1 : 2,
          py: 1
        }}>
          <Typography
            variant={isSmallMobile ? "subtitle1" : "h6"}
            sx={{ fontSize: isSmallMobile ? '1rem' : '1.25rem' }}
          >
            Admin Dashboard
          </Typography>
          <IconButton
            color="inherit"
            onClick={handleLogout}
            size={isSmallMobile ? "small" : "medium"}
          >
            <LogoutIcon fontSize={isSmallMobile ? "small" : "medium"} />
          </IconButton>
        </Box>
      </AppBar>

      <Container
        maxWidth="lg"
        sx={{
          mt: isSmallMobile ? 2 : 4,
          mb: isSmallMobile ? 2 : 4,
          flex: 1,
          px: isSmallMobile ? 1 : 3
        }}
      >
        {tempError && (
          <Alert 
            severity="success" 
            sx={{ 
              mb: 2,
              position: 'fixed',
              top: '20px',
              right: '20px',
              zIndex: 9999,
              animation: 'fadeInOut 3s ease-in-out',
              ...fadeInOut
            }}
          >
            {tempError}
          </Alert>
        )}
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <Paper sx={{ width: '100%', mb: 2 }}>
          <Box sx={{
            p: isSmallMobile ? 1.5 : 2,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexDirection: isSmallMobile ? 'column' : 'row',
            gap: isSmallMobile ? 1 : 0
          }}>
            <Typography
              variant={isSmallMobile ? "subtitle1" : "h6"}
              component="div"
              sx={{ fontSize: isSmallMobile ? '1.1rem' : '1.25rem' }}
            >
              Clients
            </Typography>
            <Button
              variant="contained"
              startIcon={!isSmallMobile && <AddIcon />}
              onClick={handleAddClient}
              sx={{
                backgroundColor: '#F79233',
                fontSize: isSmallMobile ? '0.875rem' : '1rem',
                padding: isSmallMobile ? '6px 12px' : '8px 16px'
              }}
              size={isSmallMobile ? "small" : "medium"}
            >
              {isSmallMobile ? 'Add' : 'Add Client'}
            </Button>
          </Box>
          <List>
            {clients.map((client) => (
              <React.Fragment key={client._id}>
                <ListItem
                  sx={{
                    flexDirection: isMobile ? 'column' : 'row',
                    alignItems: isMobile ? 'stretch' : 'center',
                    gap: isMobile ? 1 : 0,
                    py: isMobile ? 2 : 1,
                    px: isSmallMobile ? 1 : 2
                  }}
                >
                  <ListItemText
                    primary={client.organization_name}
                    secondary={
                      <>
                        <Typography
                          component="span"
                          variant={isSmallMobile ? "caption" : "body2"}
                          sx={{ fontSize: isSmallMobile ? '0.75rem' : '0.875rem' }}
                        >
                          SPOC: {client.spoc_name}
                        </Typography>
                        <br />
                        <Typography
                          component="span"
                          variant={isSmallMobile ? "caption" : "body2"}
                          sx={{ fontSize: isSmallMobile ? '0.75rem' : '0.875rem' }}
                        >
                          Email: {client.email}
                        </Typography>
                        <br />
                        <Typography
                          component="span"
                          variant={isSmallMobile ? "caption" : "body2"}
                          sx={{ fontSize: isSmallMobile ? '0.75rem' : '0.875rem' }}
                        >
                          Registration No: {client.registration_number}
                        </Typography>
                        <br />
                        <Typography
                          component="span"
                          variant={isSmallMobile ? "caption" : "body2"}
                          sx={{ fontSize: isSmallMobile ? '0.75rem' : '0.875rem' }}
                        >
                          GST No: {client.gst_number}
                        </Typography>
                        <br />
                        <Typography
                          component="span"
                          variant={isSmallMobile ? "caption" : "body2"}
                          sx={{ fontSize: isSmallMobile ? '0.75rem' : '0.875rem' }}
                        >
                          Mobile No: {client.mobile_number}
                        </Typography>
                        <br />
                        <Typography
                          component="span"
                          variant={isSmallMobile ? "caption" : "body2"}
                          sx={{ fontSize: isSmallMobile ? '0.75rem' : '0.875rem' }}
                        >
                          Type: {client.type}
                        </Typography>
                      </>
                    }
                    sx={{
                      mb: isMobile ? 1 : 0,
                      minWidth: isMobile ? '100%' : 'auto'
                    }}
                  />
                  {!isMobile ? (
                    <ListItemSecondaryAction>
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        <Tooltip title="Edit Client">
                          <IconButton
                            onClick={() => handleEditClient(client)}
                            sx={{ color: '#F79233' }}
                            size="small"
                          >
                            <EditIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="View Details">
                          <IconButton
                            onClick={() => handleShowDetails(client, 'client')}
                            sx={{ color: '#F79233' }}
                            size="small"
                          >
                            <VisibilityIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Change Password">
                          <IconButton
                            onClick={() => setPasswordDialog({
                              open: true,
                              clientId: client._id,
                              newPassword: '',
                              confirmPassword: '',
                              errors: {}
                            })}
                            sx={{ color: '#F79233' }}
                            size="small"
                          >
                            <LockIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Delete Client">
                          <IconButton
                            onClick={() => handleDeleteClient(client._id)}
                            sx={{ color: '#F79233' }}
                            size="small"
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </ListItemSecondaryAction>
                  ) : (
                    <Box sx={{
                      display: 'flex',
                      gap: isSmallMobile ? 0.5 : 1,
                      flexWrap: 'wrap',
                      justifyContent: 'center',
                      width: '100%'
                    }}>
                      <Tooltip title="Edit Client">
                        <IconButton
                          onClick={() => handleEditClient(client)}
                          sx={{ color: '#F79233' }}
                          size={isSmallMobile ? "small" : "medium"}
                          className="touch-target"
                        >
                          <EditIcon fontSize={isSmallMobile ? "small" : "medium"} />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="View Details">
                        <IconButton
                          onClick={() => handleShowDetails(client, 'client')}
                          sx={{ color: '#F79233' }}
                          size={isSmallMobile ? "small" : "medium"}
                          className="touch-target"
                        >
                          <VisibilityIcon fontSize={isSmallMobile ? "small" : "medium"} />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Change Password">
                        <IconButton
                          onClick={() => setPasswordDialog({
                            open: true,
                            clientId: client._id,
                            newPassword: '',
                            confirmPassword: '',
                            errors: {}
                          })}
                          sx={{ color: '#F79233' }}
                          size={isSmallMobile ? "small" : "medium"}
                          className="touch-target"
                        >
                          <LockIcon fontSize={isSmallMobile ? "small" : "medium"} />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Delete Client">
                        <IconButton
                          onClick={() => handleDeleteClient(client._id)}
                          sx={{ color: '#F79233' }}
                          size={isSmallMobile ? "small" : "medium"}
                          className="touch-target"
                        >
                          <DeleteIcon fontSize={isSmallMobile ? "small" : "medium"} />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  )}
                </ListItem>
                <Divider />
              </React.Fragment>
            ))}
          </List>
        </Paper>
      </Container>

      <DetailView
        open={!!selectedItem}
        onClose={() => {
          setSelectedItem(null);
          setDetailViewType(null);
        }}
        data={selectedItem}
        type={detailViewType}
      />

      <Dialog 
        open={clientForm.open} 
        onClose={() => setClientForm(prev => ({ ...prev, open: false }))}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <Typography variant="h6" component="div" sx={{ color: '#F79233' }}>
            {clientForm.mode === 'add' ? 'Add New Client' : 'Edit Client'}
          </Typography>
          {clientForm.mode === 'add' && (
            <div style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
              <Tooltip title="Save Draft">
                <IconButton onClick={handleSaveDraft} size="small">
                  <SaveIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Load Draft">
                <IconButton 
                  onClick={handleLoadDraft} 
                  size="small"
                  disabled={!draft}
                >
                  <RestoreIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Clear Form">
                <IconButton onClick={handleClearForm} size="small">
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
            </div>
          )}
        </DialogTitle>
        <form onSubmit={handleClientSubmit}>
          <DialogContent>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Organization Name"
                    value={clientForm.data.organization_name}
                    onChange={(e) => setClientForm(prev => ({
                      ...prev,
                      data: { ...prev.data, organization_name: e.target.value },
                      errors: { ...prev.errors, organization_name: '' }
                    }))}
                    required
                    error={!!clientForm.errors.organization_name}
                    helperText={clientForm.errors.organization_name}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="SPOC Name"
                    value={clientForm.data.spoc_name}
                    onChange={(e) => setClientForm(prev => ({
                      ...prev,
                      data: { ...prev.data, spoc_name: e.target.value },
                      errors: { ...prev.errors, spoc_name: '' }
                    }))}
                    required
                    error={!!clientForm.errors.spoc_name}
                    helperText={clientForm.errors.spoc_name}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Address"
                    value={clientForm.data.address}
                    onChange={(e) => setClientForm(prev => ({
                      ...prev,
                      data: { ...prev.data, address: e.target.value },
                      errors: { ...prev.errors, address: '' }
                    }))}
                    required
                    multiline
                    rows={2}
                    error={!!clientForm.errors.address}
                    helperText={clientForm.errors.address}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth error={!!clientForm.errors.mobile_number}>
                    <TextField
                      label="Mobile Number"
                      value={clientForm.data.mobile_number}
                      onChange={(e) => setClientForm(prev => ({
                        ...prev,
                        data: { ...prev.data, mobile_number: e.target.value },
                        errors: { ...prev.errors, mobile_number: '' }
                      }))}
                      required
                      InputProps={{
                        startAdornment: (
                          <Select
                            value={clientForm.data.country_code}
                            onChange={(e) => setClientForm(prev => ({
                              ...prev,
                              data: { ...prev.data, country_code: e.target.value }
                            }))}
                            variant="standard"
                            disableUnderline
                            sx={{
                              mr: 1,
                              minWidth: 'auto',
                              px: 1,
                              background: 'transparent',
                              '& .MuiSelect-select': {
                                padding: 0,
                                minWidth: `${clientForm.data.country_code.length * 10 + 40}px`,
                              },
                              '& fieldset': {
                                border: 'none',
                              },
                              '& .MuiOutlinedInput-notchedOutline': {
                                border: 'none',
                              },
                            }}
                          >
                            <MenuItem value="+91">+91</MenuItem>
                            <MenuItem value="+1">+1</MenuItem>
                            <MenuItem value="+44">+44</MenuItem>
                          </Select>
                        )
                      }}
                    />
                    {clientForm.errors.mobile_number && (
                      <FormHelperText>{clientForm.errors.mobile_number}</FormHelperText>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Email"
                    type="email"
                    value={clientForm.data.email}
                    onChange={(e) => setClientForm(prev => ({
                      ...prev,
                      data: { ...prev.data, email: e.target.value },
                      errors: { ...prev.errors, email: '' }
                    }))}
                    required
                    error={!!clientForm.errors.email}
                    helperText={clientForm.errors.email}
                  />
                </Grid>
                {clientForm.mode === 'add' && (
                  <>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Password"
                        type="password"
                        value={clientForm.data.password}
                        onChange={(e) => setClientForm(prev => ({
                          ...prev,
                          data: { ...prev.data, password: e.target.value },
                          errors: { ...prev.errors, password: '' }
                        }))}
                        required
                        error={!!clientForm.errors.password}
                        helperText={clientForm.errors.password}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Confirm Password"
                        type="password"
                        value={clientForm.data.confirmPassword}
                        onChange={(e) => setClientForm(prev => ({
                          ...prev,
                          data: { ...prev.data, confirmPassword: e.target.value },
                          errors: { ...prev.errors, confirmPassword: '' }
                        }))}
                        required
                        error={!!clientForm.errors.confirmPassword}
                        helperText={clientForm.errors.confirmPassword}
                      />
                    </Grid>
                  </>
                )}
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Registration Number"
                    value={clientForm.data.registration_number}
                    onChange={(e) => setClientForm(prev => ({
                      ...prev,
                      data: { ...prev.data, registration_number: e.target.value },
                      errors: { ...prev.errors, registration_number: '' }
                    }))}
                    required
                    error={!!clientForm.errors.registration_number}
                    helperText={clientForm.errors.registration_number}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="GST Number"
                    value={clientForm.data.gst_number}
                    onChange={(e) => setClientForm(prev => ({
                      ...prev,
                      data: { ...prev.data, gst_number: e.target.value },
                      errors: { ...prev.errors, gst_number: '' }
                    }))}
                    required
                    error={!!clientForm.errors.gst_number}
                    helperText={clientForm.errors.gst_number}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    select
                    label="Organization Type"
                    value={clientForm.data.type}
                    onChange={(e) => setClientForm(prev => ({
                      ...prev,
                      data: { ...prev.data, type: e.target.value },
                      errors: { ...prev.errors, type: '' }
                    }))}
                    required
                    error={!!clientForm.errors.type}
                    helperText={clientForm.errors.type}
                  >
                    {organizationTypes.map((type) => (
                      <MenuItem key={type} value={type}>
                        {type}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              </Grid>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setClientForm(prev => ({ ...prev, open: false }))}>
              Cancel
            </Button>
            <Button type="submit" variant="contained" color="primary">
              {clientForm.mode === 'add' ? 'Add' : 'Update'}
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      {/* Password Update Dialog */}
      <Dialog
        open={passwordDialog.open}
        onClose={() => setPasswordDialog({
          open: false,
          clientId: null,
          newPassword: '',
          confirmPassword: '',
          errors: {}
        })}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Typography variant="h6" component="div" sx={{ color: '#F79233' }}>
            Update Password
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
            <TextField
              fullWidth
              label="New Password"
              type="password"
              value={passwordDialog.newPassword}
              onChange={(e) => setPasswordDialog(prev => ({
                ...prev,
                newPassword: e.target.value,
                errors: { ...prev.errors, newPassword: '' }
              }))}
              required
              error={!!passwordDialog.errors.newPassword}
              helperText={passwordDialog.errors.newPassword}
            />
            <TextField
              fullWidth
              label="Confirm Password"
              type="password"
              value={passwordDialog.confirmPassword}
              onChange={(e) => setPasswordDialog(prev => ({
                ...prev,
                confirmPassword: e.target.value,
                errors: { ...prev.errors, confirmPassword: '' }
              }))}
              required
              error={!!passwordDialog.errors.confirmPassword}
              helperText={passwordDialog.errors.confirmPassword}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setPasswordDialog({
            open: false,
            clientId: null,
            newPassword: '',
            confirmPassword: '',
            errors: {}
          })}>
            Cancel
          </Button>
          <Button onClick={handlePasswordUpdate} variant="contained" color="primary">
            Update Password
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default AdminDashboard; 